//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar'
import mainMenuTab from '@/components/mainMenuTab'

export default {
    components: {
         mainMenuTab, navbar
    },

    data(){
        return {
            stores:[],
            current:0,
            // page:1,
            // num:1,
            // size:15,
            cart:{},
            settlement:{
                price: 0,
                quantity: 0,
                deposit: 0,
            },
        }
    },
    methods:{
        submitCart() {
            let specid = [];
            // let push = true;
            this.stores[this.current].data.forEach(val=>{
                if(val.quantity>0){
                    // if(val.quantity > val.stock) {
                    //     this.$vux.toast.text(val.goods_name + "库存不足.");
                    //     push = false;
                    //     return;
                    // }
                    specid.push(val.spec_id);
                }
            })

            if(specid.length<1){
                return false;
            }

            this.$router.push( "/orderConfirm?spec_id="+specid.join(",") );

        },
         // 查询商品分类列表
        changeGoodsQuantity(spec,v){
            //console.log(this.settlement[this.current].spec_id);
            //this.settlement[this.current].spec_id[spec_id] += v;
            if(spec.quantity+v >= 0 && spec.quantity + v <= spec.stock) {
                spec.quantity+=v;
                this.updatePrice(true);
            }else if(spec.quantity + v > spec.stock) {
                this.$vux.toast.text("库存不足.");
            }
        },
        modifyGoodsQuantity(spec,event) {
            ///console.log(event.target.value);
            let v = event.target.value;
            if(v === "")return;
            if(v >= 0 && v <= spec.stock) {
                spec.quantity=v;
                this.updatePrice(true);
            }
            else if(v > spec.stock) {
                this.$vux.toast.text("库存不足.");
            }
        },
        updateTotalPrice(spec_hash) {
            let that = this;
            if(!(this.current in this.cart)) {
                that.settlement.price = 0;
                that.settlement.quantity = 0;
                that.settlement.deposit = 0;
                return;
            }
            let cart = this.cart[this.current];
            let p=0,d=0,q=0;
            if(cart.length) {
                cart.forEach(v => {
                    // console.log(v);
                    if(v.store.store_id == that.current) {
                        v.items.forEach(item => {
                            // console.log(spec_hash);
                            if(item.spec_id in spec_hash) {
                                p+=item.total*1;
                                d+=item.deposit*1;
                                q+=item.quantity*1;
                            }
                        });
                    }
                });
                that.settlement.price = p;
                that.settlement.quantity = q;
                that.settlement.deposit = d;
            }
        },
        updatePrice(requestCart) {

            let specid = [],quantity=[],spec_hash={};

            this.stores[this.current].data.forEach(val=>{
                if(val.spec_id>0 && val.quantity>0){
                    specid.push(val.spec_id);
                    quantity.push(val.quantity);
                    spec_hash[val.spec_id] = val.quantity;
                }
            })
            if(!requestCart) {
                this.updateTotalPrice(spec_hash);
                return;
            }
            const opts = {
                url: api.cartAdd,
                data: {
                    spec_id: specid.join(),
                    quantity: quantity.join(),
                    storeId: common.getCurStoreId()
                }
            }
            specid.length && common.query(opts).then(res=>{
                //this.$router.push("/cart");
                // console.log(res);
                this.cart[this.current] = res.data;
                this.updateTotalPrice(spec_hash);
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },
        queryData(){
            let _this = this;
            let opts = {
                url: api.myQuickBuy,
                data:{

                },
                type:'get'
            };
            //let allGoodsTitle = { /*cate_id: -1, cate_name: "全部"*/ }
            common.query(opts).then(
                res => {
                    //res.data.unshift(allGoodsTitle)
                     _this.stores = res.data
                     if(Object.keys(res.data).length) {
                         _this.buy(Object.keys(res.data)[0]);
                     }
                },
                res => {
                    _this.$vux.toast.text(res.message);
                }
            );
        },

        buy(store_id){
            if(!(store_id in this.stores)) {
                this.$vux.toast.text("无效的店铺ID：" + store_id);
                return;
            }
            this.current = store_id;
            this.updatePrice(false);
        },
        pullUpLoad(){
          let _this = this;
          let scrollTop = document.documentElement.scrollTop;
          let clientHeight =document.body.clientHeight;
          let pageHeight=document.body.scrollHeight;

          if(scrollTop+clientHeight>=pageHeight){
             _this.page = _this.page+1
            if(this.page <= this.totalPage){
                //_this.$refs.child.querySearchGoods(this.caryId)

            }


          }
        },

        //跳转购物车
        goCart(){
            this.$router.push({name: "cart"});
        },

        handleScroll(){
            console.log(1)
        }
    },
    mounted(){
        this.queryData()
        this.searchContent=this.$route.query.sContent
        document.addEventListener("scroll", this.pullUpLoad,true);

    },
}



// WEBPACK FOOTER //
// ./src/views/pages/quickBuy.vue